import React from "react";
import PropTypes from "prop-types";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import {
  Container,
  Title,
  Text,
  DetailsList,
  ListItem
} from "./WarningBox.styled";

/**
 * A component to display warning messages for subscription changes
 */
const WarningBox = ({
  isUpgrade = false,
  hasRefund = false,
  warningItems = []
}) => {
  return (
    <Container>
      <Title>
        You are {isUpgrade ? 'upgrading' : 'downgrading'} your subscription!
      </Title>
      
      {isUpgrade ? (
        <Text>
          You'll immediately get access to your new features
          {hasRefund && ' and you\'ll be refunded for the unused portion of your current subscription'}.
        </Text>
      ) : (
        <Text>
          {warningItems.length > 0 ? (
            <DetailsList>
              {warningItems.map((item, index) => (
                <ListItem key={index}>{item}</ListItem>
              ))}
            </DetailsList>
          ) : (
            <DetailsList>
              <ListItem>Changes will take effect immediately, and you'll lose access to features not included in the lower plan.</ListItem>
              <ListItem>All Referrals will be permanently forfeited unless you resubscribe to a Premium or higher subscription level within 30 days.</ListItem>
            </DetailsList>
          )}
        </Text>
      )}
    </Container>
  );
};

WarningBox.propTypes = {
  isUpgrade: PropTypes.bool,
  hasRefund: PropTypes.bool,
  warningItems: PropTypes.arrayOf(PropTypes.string)
};

export default WarningBox; 